import { AppDispatch } from '../../store';
import { setLoading, setError, setSuccess } from '../app/appSlice';
import { MarketController, MarketPayload } from '../../api/controllers/market.controller';
import { setMarket, setMarkets } from './marketsSlice';
import { Market } from '../../types';

export const getMarkets = (payload: { campaign_id: string }) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(''));

    const response = await MarketController.getMarkets(payload);

    dispatch(setMarkets(response.data));
    dispatch(setSuccess(true));
  } catch (error: any) {
    dispatch(setError('Fetching ad sets failed. please try it again later'));
    dispatch(setSuccess(false));
  } finally {
    dispatch(setLoading(false));
  }
};

export const getMarket = (payload: { id: string }) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(''));

    const response = await MarketController.getMarket(payload);

    dispatch(setMarket(response.data));
    dispatch(setSuccess(true));
  } catch (error: any) {
    dispatch(setError('Fetching ad sets failed. please try it again later'));
    dispatch(setSuccess(false));
  } finally {
    dispatch(setLoading(false));
  }
};

export const createMarket = (payload: MarketPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setError(''));

    const response = await MarketController.createMarket(payload);

    dispatch(setMarket(response.data));
    dispatch(setSuccess(true));
    return response.data;
  } catch (error: any) {
    dispatch(setError('Creating a new ad set failed. please try it again later'));
    dispatch(setSuccess(false));
    return null;
  }
};


export const updateMarket = (payload: { market_id: string, updated_data?: Partial<Market> }) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setError(''));

    const response = await MarketController.updateMarket(payload);

    dispatch(setMarket(response.data));
    dispatch(setSuccess(true));
    return response.data;
  } catch (error: any) {
    dispatch(setError('Creating a new campaign failed. please try it again later'));
    dispatch(setSuccess(false));
    return null;
  }
};
